import { render, staticRenderFns } from "./slider-index.vue?vue&type=template&id=5ce25065"
import script from "./slider-index.vue?vue&type=script&lang=js"
export * from "./slider-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SliderIndexSlideNew: require('/var/www/components/slider-index/slider-index-slide-new.vue').default})
